import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-mi-paquete',
  templateUrl: './mi-paquete.component.html',
  styleUrls: ['./mi-paquete.component.scss']
})
export class MiPaqueteComponent implements OnInit {
  solicitado = 0;
  data;
  respuestaGuardar:any;
  respuestaPaqueteCliente:any;
  paqueteCliente;
  clienteid;
  respuestaEliminarPaqueteCliente:any;
  respuestaEliminarColor:any;
  respuestaEliminarMoldura:any;
  respuestaEliminarPlaca:any;
  respuestaEliminarViajeCliente:any;
  respuestaSolicitado:any;
  respuestaEliminarBoletosAdulto:any;
  respuestaEliminarBoletosNino:any;
  respuestaEliminarAnillo:any;
  respuestaEliminarProductoCliente:any;
  respuestaAplicarDescuento:any;
  respuestaEliminarFondoMoldura:any;
  respuestaGet:any;
  paquetesSeleccionados;
  placasSeleccionados;
  moldurasSeleccionados;
  coloresSeleccionados;
  viajesSeleccionados;
  fiestasSeleccionadas;
  anillosSeleccionados;
  descuentosAplicados;
  productosSeleccionados;
  dedicatoriasSeleccionadas;
  fondosMoldurasSeleccionados;
  total;
  codigo_descuento;
  clienteId;
  admin = true;
  datosCliente;

  constructor(private _solicitarPaquete: ClientesService, private _getPaqueteCliente:ClientesService,
    private _eliminarPaqueteCliente:ClientesService, private _eliminarColorCliente:ClientesService, 
    private _getSolicitado:ClientesService, private _eliminarViajeCliente:ClientesService,
    private _eliminarMoldura:ClientesService, private _eliminarPlaca:ClientesService,
    private _eliminarFondoMolduraCliente:ClientesService,
    private _eliminarAnilloCliente:ClientesService, private iziToast:Ng2IzitoastService,
    private _eliminarProductoCliente:ClientesService, private _get:LoginService,
    private actRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe(params => {
      this.clienteId = this.actRoute.snapshot.paramMap.get('cliente');
      if ( this.clienteId){
        this.getSolicitado(this.clienteId);
        this.getPaqueteCliente(this.clienteId);
        this.admin = false;
        this.getTipoUsuario();
      }else{
        this.getDataCliente();
        this.admin = false;
      }
      
    });

    
  }

  getTipoUsuario(){
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          if(this.datosCliente.is_staff == true){
            this.admin = true;
          }else{
            this.admin = false;
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getDataCliente(){
    console.log('entraaaaa');
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.clienteId = this.datosCliente.id;
          this.clienteid = this.datosCliente.id;
          this.getSolicitado(this.clienteId);
          this.getPaqueteCliente(this.clienteId);
          // alert(this.datosCliente.grupo);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  aplicarDescuento(cliente){
    this.data = {
      'codigo_descuento': this.codigo_descuento,
      'usuario': cliente
    }

    this._getSolicitado.aplicarDescuento(this.data).subscribe(
      data => {
        this.respuestaAplicarDescuento = data;
        console.log(this.respuestaAplicarDescuento.success);
        if(this.respuestaAplicarDescuento.success == 1){
            this.iziToast.show(
              {
                  title: this.respuestaAplicarDescuento.mensaje,
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
          this.codigo_descuento = '';
          this.clienteid = cliente;
        }else if(this.respuestaAplicarDescuento.success == 2){
          this.iziToast.show(
            {
                title: this.respuestaAplicarDescuento.mensaje,
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.codigo_descuento = '';
          this.clienteid = cliente;
          window.location.reload();
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un error, intenta más tarde ',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        this.clienteid = cliente;
        }
      }, error => console.error(error)
    )
  }

  getSolicitado(cliente){
    // alert(cliente);
    this.data = {
      'usuario':cliente
    }

    this._getSolicitado.getSolicitado(this.data).subscribe(
      data => {
        this.respuestaSolicitado = data;
        if(this.respuestaSolicitado.success){
          this.solicitado = this.respuestaSolicitado.content.solicitado;
          // alert(this.solicitado);
          this.clienteid = cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getPaqueteCliente(cliente){
    this.data = {
      'cliente':cliente
    }

    this._getPaqueteCliente.getPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaPaqueteCliente = data;
        if(this.respuestaPaqueteCliente.success){
          this.paqueteCliente = this.respuestaPaqueteCliente.content;
          this.paquetesSeleccionados = this.paqueteCliente.paquetes;
          this.moldurasSeleccionados = this.paqueteCliente.molduras;
          this.coloresSeleccionados = this.paqueteCliente.colores;
          this.placasSeleccionados = this.paqueteCliente.placas;
          this.viajesSeleccionados = this.paqueteCliente.viajes;
          this.fiestasSeleccionadas = this.paqueteCliente.fiestas;
          this.anillosSeleccionados = this.paqueteCliente.anillos;
          this.descuentosAplicados = this.paqueteCliente.descuentos;
          this.productosSeleccionados = this.paqueteCliente.productos;
          this.dedicatoriasSeleccionadas = this.paqueteCliente.dedicatorias;
          this.fondosMoldurasSeleccionados = this.paqueteCliente.fondosMolduras;
          
          this.total = this.paqueteCliente.total;
          this.clienteid = cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  guardarPaquete(cliente){
    this.data = {
      'cliente':cliente
    }

    this._solicitarPaquete.solicitarPaquete(this.data).subscribe(
      data => {
        this.respuestaGuardar = data;
        if(this.respuestaGuardar.success){
          this.getPaqueteCliente(cliente);
          window.location.reload();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarPaqueteCliente(paquete, cliente){
    this.data = {
      'paqueteCliente':paquete
    }

    this._eliminarPaqueteCliente.eliminarPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarPaqueteCliente = data;
        if(this.respuestaEliminarPaqueteCliente.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarColorCliente(color, cliente){
    this.data = {
      'color':color
    }

    this._eliminarColorCliente.eliminarColorUsuario(this.data).subscribe(
      data => {
        this.respuestaEliminarColor = data;
        if(this.respuestaEliminarColor.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarDedicatoriaCliente(dedicatoria, cliente){
    this.data = {
      'dedicatoria':dedicatoria
    }

    this._eliminarColorCliente.eliminarDedicatoriaCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarColor = data;
        if(this.respuestaEliminarColor.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarDescuentoCliente(descuento, cliente){
    this.data = {
      'descuento':descuento
    }

    this._eliminarColorCliente.eliminarDescuentoCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarColor = data;
        if(this.respuestaEliminarColor.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarFondoMolduraCliente(fondoMoldura, cliente){
    this.data = {
      'fondoMoldura':fondoMoldura
    }

    this._eliminarFondoMolduraCliente.eliminarFondoMolduraCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarFondoMoldura = data;
        if(this.respuestaEliminarFondoMoldura.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarViajeCliente(viaje, cliente){
    this.data = {
      'viaje':viaje
    }

    this._eliminarViajeCliente.eliminarViajeCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarViajeCliente = data;
        if(this.respuestaEliminarViajeCliente.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarPlaca(placa, cliente){
    this.data = {
        'placa':placa
    }

    this._eliminarPlaca.eliminarPlaca(this.data).subscribe(
      data => {
        this.respuestaEliminarPlaca = data;
        if(this.respuestaEliminarPlaca.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarMoldura(moldura, cliente){
    console.log(moldura);
    this.data = {
        'moldura':moldura
    }

    this._eliminarMoldura.eliminarMoldura(this.data).subscribe(
      data => {
        this.respuestaEliminarMoldura = data;
        if(this.respuestaEliminarMoldura.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarBoletosAdulto(fiesta, cliente){
    this.data = {
        'fiesta':fiesta
    }

    this._eliminarMoldura.eliminarBoletosAdulto(this.data).subscribe(
      data => {
        this.respuestaEliminarBoletosAdulto = data;
        if(this.respuestaEliminarBoletosAdulto.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarBoletosNino(fiesta, cliente){
    this.data = {
        'fiesta':fiesta
    }

    this._eliminarMoldura.eliminarBoletosNino(this.data).subscribe(
      data => {
        this.respuestaEliminarBoletosNino = data;
        if(this.respuestaEliminarBoletosNino.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarAnilloCliente(anillo, cliente){
    this.data = {
      'anillo':anillo
    }

    this._eliminarAnilloCliente.eliminarAnilloCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarAnillo= data;
        if(this.respuestaEliminarAnillo.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarProductoCliente(producto, cliente){
    this.data = {
      'productoCliente':producto
    }

    this._eliminarProductoCliente.eliminarProductoCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarProductoCliente = data;
        if(this.respuestaEliminarProductoCliente.success){
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  
}
